import React, { useEffect, useRef } from 'react';
import { cn } from '@/utils/cn';
import Icon from '../Icon';
import ProductFilterOption from './ProductFilterOption';
import TextBase from '../Typography/TextBase';

function ProductFilterOptionsWrapper({
  collapsedItems,
  filterData,
  filter,
  handleCollapse,
  isCollapsed,
  handleSelect,
  isLastItem,
}) {
  const contentRefs = useRef({});
  // Recalculate heights whenever filterKey updates
  useEffect(() => {
    setTimeout(() => {
      Object.keys(contentRefs.current).forEach((key) => {
        if (contentRefs.current[key]) {
          contentRefs.current[key].style.height = collapsedItems?.[key]
            ? '0px'
            : `${contentRefs.current[key]?.scrollHeight || 'max-content'}px`;
          contentRefs.current[key].style.visibility = collapsedItems?.[key]
            ? 'hidden'
            : 'visible';
        }
      });
    }, 100); // Delay to allow DOM updates
  }, [filterData, collapsedItems]);

  return (
    <div
      key={filter.filterCollapsed}
      className="product-filter-options-wrapper"
    >
      <div
        role="presentation"
        className="flex items-center justify-between mb-6 cursor-pointer"
        onClick={() => handleCollapse(filter?.filterCollapsed)}
      >
        <TextBase className="text-base font-semibold capitalize">
          {filter?.name?.en ? filter?.name?.en : filter?.name} ({filter.count})
        </TextBase>
        <Icon
          type="angle-down"
          className={cn(
            'size-[24px] rotate-180 transition-transform duration-200',
            {
              '!rotate-0': isCollapsed,
            },
          )}
        />
      </div>
      <div
        className="collapse transition-all duration-300 overflow-hidden"
        style={{
          height: isCollapsed
            ? '0px'
            : `${contentRefs.current[filter.id]?.scrollHeight || 0}px`,
          maxHeight: 'max-content',
          visibility: isCollapsed ? 'hidden' : 'visible',
        }}
        ref={(el) => {
          contentRefs.current[filter.filterCollapsed] = el;
        }}
      >
        {filter?.data?.map((item, index) => (
          <ProductFilterOption
            key={`${index}-${item.count}`}
            handleSelect={handleSelect}
            item={item}
          />
        ))}
      </div>

      {!isLastItem && (
        <div className="my-16 border-b border-aquarelle-purple" />
      )}
    </div>
  );
}

export default ProductFilterOptionsWrapper;
